import { Pipe, PipeTransform } from '@angular/core';
import { Utils } from '../../../_helpers/utilities';

@Pipe({
    name: 'emsnseToEsm'
})
export class EmsnseToEsmPipe implements PipeTransform {

    transform(value: any): any {
        return Utils.checkEsmMarket(value);
    }

}
